import {
    ROUTES_UNAUTHORIZED,
    ROUTES_SQUADS,
    ROUTES_SQUAD_FORM,
    ROUTES_SQUADS_MAIN,
    ROUTES_SQUADS_LEAVE
} from '@/constants/routes';
import store from '@/store';
import { i18n } from '@/lang';

export default {
    path: '/squads',
    name: ROUTES_SQUADS_MAIN,
    component: () => import(/*webpackChunkName: 'squads'*/ '@/views/Squads.vue'),
    redirect: { name: ROUTES_SQUADS },
    children: [
        {
            path: '/squads/overview/:squadId?',
            name: ROUTES_SQUADS,
            beforeEnter: guardRouteSquads,
            component: () => import(/*webpackChunkName: 'squads'*/ '@/components/squads/Squads.vue')
        },
        {
            path: '/squads/form/:squadId?',
            name: ROUTES_SQUAD_FORM,
            beforeEnter: guardRouteSquadsForm,
            component: () => import(/*webpackChunkName: 'squads'*/ '@/components/squads/CreateSquad.vue')
        },
        {
            path: '/squads/leave/:squadId/:clubId',
            name: ROUTES_SQUADS_LEAVE,
            beforeEnter: guardRouteSquads,
            component: () => import(/*webpackChunkName: 'squads'*/ '@/components/squads/LeaveSquad.vue')
        }
    ]
};

function guardRouteSquads(to, from, next) {
    if (store.getters.isSelectedClubIndividual) {
        store.dispatch('notifyError', { message: i18n.t('notAuthorizedToSeeThisPage') });
        next({ name: ROUTES_UNAUTHORIZED });
    } else {
        next();
    }
}

function guardRouteSquadsForm(to, from, next) {
    const canNotCreate = !to.params.squadId && !store.getters['userPermissions/canCreateSquads'];
    const canNotEdit = to.params.squadId && !store.getters['userPermissions/canEditSquads'];

    if (store.getters.isSelectedClubIndividual || canNotCreate || canNotEdit) {
        store.dispatch('notifyError', { message: i18n.t('notAuthorizedToSeeThisPage') });
        next({ name: ROUTES_UNAUTHORIZED });
    } else {
        next();
    }
}
